






























































































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../../../shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {Lading, Warehouse} from "@/interfaces/entity";
import {LadingPaymentType} from "@/enums/type";
import {PickingListType} from "@/enums/type/pickinglisttype";

@Component({
    name: "PLPrintContent"
})
export default class extends mixins(CommonMixin) {
    @Prop({ type: Array, default: [] }) readonly warehouses!: Array<Warehouse>;
    @Prop({ type: String, default: null }) readonly postOfficeFrom!: string;
    @Prop({ type: String, default: null }) readonly postOfficeTo!: string;
    @Prop({ type: String, default: null }) readonly employee!: string;
    @Prop({ type: Number, default: 0 }) readonly pickingListType!: number;

    PickingListType = PickingListType;
    get totalTable() {
        let totalWeight = 0,
        totalBox = 0,
        totalMoney = 0;

        this.warehouses.forEach((warehouse: Warehouse) => {
            totalWeight += this.getProp(warehouse, "billLading.weight") || 0;
            totalBox += this.getProp(warehouse, "billLading.boxQuantity") || 0;
            totalMoney += this.moneyReceivable(warehouse.billLading);
        });

        return { totalWeight, totalBox, totalMoney };
    }

    moneyReceivable(lading?: Lading): number {
        if (lading?.payment === LadingPaymentType.Receiver) {
            return (lading?.codMoney || 0) + lading?.totalFee;
        } else if (lading?.payment === LadingPaymentType.Cash) {
            return lading?.codMoney || 0;
        }
        return 0;
    }
}
